import {
  Applicant,
  ApplicantType,
  Application as SharedApplication,
  ApplicationStatus
} from "shared/types";
import { Application } from "types/application";

const getNonCoSignersForApplication = (
  application: Application | SharedApplication
) => {
  return getNonCoSigners([
    ...application.applicants,
    ...(application.pending_magic_links || [])
  ]);
};

export const getNonCoSigners = (applicants: Pick<Applicant, "role">[]) => {
  const nonCoSignerApplicants = applicants.filter(
    (a) => a.role !== ApplicantType.CoSigner
  );
  return nonCoSignerApplicants.length;
};

export const getApplicationSplittingTooltip = (
  application: Application | SharedApplication
) => {
  if (application.status === ApplicationStatus.OnHold)
    return "You need to resume the application before splitting";
  else if (
    [
      ApplicationStatus.Approved,
      ApplicationStatus.Rejected,
      ApplicationStatus.ConditionalApproved
    ].includes(application.status)
  )
    return "You can't split the application once a decision has been made";
  else if (getNonCoSignersForApplication(application) < 2)
    return "Only applications with more than one applicant and/or occupant can be split";

  return "";
};

export const getApplicationSplittingDisabled = (
  application: Application | SharedApplication
) => {
  return (
    [
      ApplicationStatus.Approved,
      ApplicationStatus.Rejected,
      ApplicationStatus.ConditionalApproved,
      ApplicationStatus.OnHold
    ].includes(application.status) ||
    getNonCoSignersForApplication(application) < 2
  );
};
